import Uppy, { UppyFile } from "@uppy/core";
import { DiscoverySession } from "../stores/jotai/discovery-session";
import axios from "axios";

interface CancelRecordingUploadParams {
    uppy: Uppy;
    file: UppyFile;
    discoverySession: DiscoverySession;
    teamID: string;
    onSuccess?: Function;
}

export const cancelRecordingUpload = (params: CancelRecordingUploadParams) => {
    const { uppy, file, discoverySession, teamID, onSuccess } = params;
    const { sessionID } = discoverySession;
    const interviewID = file.meta?.interviewID;
    const fileID = file.id;
    const s3FileURL = file.meta?.s3FileURL;
    const createNewInterview = file.meta?.createNewInterview;

    if (!!interviewID && !!s3FileURL) {
        uppy?.removeFile(fileID);

        return axios.put(
            `${process.env.NEXT_PUBLIC_LINX_URL}/storage/cancel/s3`,
            {
                fileName: s3FileURL,
                interviewID,
                teamID,
                sessionID,
                deleteInterview: !!createNewInterview,
            },
            {
                withCredentials: false,
                headers: {
                    Authorization: "Bearer " + discoverySession.apiToken,
                },
            }
        ).then((response) => {
            if (response.status === 200) {
                // When a new interview is created delete it upon cancel
                // If it is an existing interview, do not delete, restrict the call
                if (createNewInterview) {
                    if (!!onSuccess) {
                        onSuccess(response);
                    }
                }
            }
        });
    }

    return null;
};
